<div class="m-filter-keywordsearch {{ modifier && 'm-filter-keywordsearch--' + modifier || modifier }}"
	 data-t-name="FilterKeywordSearch"
	 [attr.data-t-decorator]="decorator"
	 [ngClass]="{'m-filter-keywordsearch--is-searching' : isSearching}">
	 <div class="m-filter-keywordsearch__label" *ngIf="modifier" >
		<label data-t-name="Label" class="a-label state-a-label--is-floated" >Keywords</label>
    </div>
	<div class="m-filter-keywordsearch__search-box"
		 [ngClass]="{'m-filter-keywordsearch__search-box--is-focused': isFocused }">
		<input type="text"
			   [placeholder]="placeholder"
			   class="m-filter-keywordsearch__input"
			   [disabled]="disabled"
			   [ngClass]="{'m-filter-keywordsearch__input--disabled': disabled}"
			   [(ngModel)]="searchText"
			   (keyup)="onKeyUp($event)"
			   (focus)="focusInput()"
			   (blur)="blurInput()"/>
		<cov-loading-indicator class="m-filter-keywordsearch__loader"></cov-loading-indicator>
		<div class="m-filter-keywordsearch__search-box--input-wrapper" (click)="onSearchIconClick()" *ngIf="!searchText">
			<span class="m-filter-keywordsearch__search-box--input-wrapper-icon"></span>
		</div>
		<div class="m-filter-keywordsearch__search-box--input-wrapper" (click)="onSearchClearIconClick()" *ngIf="searchText">
			<span class="m-filter-keywordsearch__search-box--input-wrapper-clear-icon"></span>
		</div>
		<div class="m-filter-keywordsearch__button-wrapper"  *ngIf="modifier" >
			<cov-button
				[modifier]="'primary'"
				[text]="searchButtonText"
				[emitEvent]="true"
				(buttonClick)="onSearchIconClick()">
			</cov-button>
		</div>
	</div>

	<ul class="m-filter-keywordsearch__dropdown"
		[ngClass]="[isOpen ? 'm-filter-keywordsearch__dropdown--is-open' : 'm-filter-keywordsearch__dropdown--is-closed', isFocused ? 'm-filter-keywordsearch__dropdown--is-focused' : '']">
		<ng-container *ngFor="let item of data">
			<li *ngIf="!item.disabled"
				class="m-filter-keywordsearch__dropdown-item"
				(mouseenter)="onMouseHover(item)"
				[ngClass]="{'m-filter-keywordsearch__dropdown-item--is-marked': checkIsMarked(item), 'm-filter-keywordsearch__dropdown-item--show-all' : isShowAll(item)}"
				(click)="onSearchItemClick(item)"
				[innerHtml]="item.name | highlight : searchText">
			</li>
			<li *ngIf="item.disabled || item.noResults"
				class="m-filter-keywordsearch__dropdown-item m-filter-keywordsearch__dropdown-item--disabled"
				[ngClass]="{'m-filter-keywordsearch__dropdown-item--no-results' : item.noResults, 'm-filter-keywordsearch__dropdown-item--label' : !item.noResults}"
				[innerHtml]="item.name">
			</li>
		</ng-container>
	</ul>
</div>
